export const FONT_SIZE_M = '0.875em';
export const FONT_SIZE_XXL = '1.25em';
export const FONT_SIZE_XXXL = '1.5em';
